import formatDistanceToNow from "date-fns/formatDistanceToNow";

export default d => (d ? `${formatDistanceToNow(d)} ago` : "N/A");
